import validate from "/root/workspace/ld_x_gw_Wdkc/node_modules/.pnpm/nuxt@3.13.2_@parcel+watcher@2.4.1_@types+node@22.5.5_eslint@9.10.0_jiti@1.21.6__ioredis@5.4.1_zw4buxwkhbnprkvp2lpr4gtbty/node_modules/nuxt/dist/pages/runtime/validate.js";
import layout_45reset_45global from "/root/workspace/ld_x_gw_Wdkc/middleware/layout-reset.global.ts";
import manifest_45route_45rule from "/root/workspace/ld_x_gw_Wdkc/node_modules/.pnpm/nuxt@3.13.2_@parcel+watcher@2.4.1_@types+node@22.5.5_eslint@9.10.0_jiti@1.21.6__ioredis@5.4.1_zw4buxwkhbnprkvp2lpr4gtbty/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  layout_45reset_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}